import React, { useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';

import EditEntityActionButtons from '../forms/EditEntityActionButtons';
import { ApiServiceServerless } from '../../xhr_libs';

export default function AddRateCollectionModal(props) {
  const {
    show,
    onHide,
    collection,
    organization_id,
    rates,
    updateList,
    showToast,
  } = props;

  const [rateId, setRateId] = useState('');

  const [isSaving, setIsSaving] = useState(false);

  const clearForm = () => {
    setRateId('');
  };

  const handleSubmit = (e) => {
    setIsSaving(true);
    e.preventDefault();
    ApiServiceServerless.post(
      `/custom_rates/collection_rate/${parseInt(collection.id)}/${rateId}`,
      { org_id: organization_id },
      { authorization_id: organization_id }
    )
      .then((res) => {
        updateList(res.data[0], 'rate_collections');
        updateList(res.data[1], 'rates');
        onHide();
        clearForm();
        setIsSaving(false);
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        onHide();
        setIsSaving(false);
        throw err;
      });
  };

  const handleCancel = () => {
    onHide();
    clearForm();
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton style={{ height: '50px' }}>
          {'Add Rate to Collection'}
        </Modal.Header>
        <Form
          noValidate
          onSubmit={handleSubmit}
          style={{
            textAlign: 'left',
          }}
        >
          <Modal.Body>
            <Row>
              <Col sm={12}>
                <Form.Group>
                  <Form.Label>Rate </Form.Label>
                  <Form.Control
                    as='select'
                    onChange={(e) => setRateId(parseInt(e.target.value))}
                  >
                    <option key={'null-val'} value={''} hidden></option>
                    {rates.filter(
                      (rate) =>
                        !collection.rate_ids.includes(rate.id) &&
                        rate.utility_type === collection.utility_type
                    ).length === 0 && (
                      <option key={'null-null'} value={''} disabled>
                        No available rates
                      </option>
                    )}
                    {rates
                      .filter(
                        (rate) =>
                          !collection.rate_ids.includes(rate.id) &&
                          rate.utility_type === collection.utility_type
                      )
                      .map((rate) => (
                        <option key={rate.id} value={rate.id}>
                          {rate.name}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <EditEntityActionButtons
              onCancel={handleCancel}
              submitDisabled={rateId === ''}
              submitShow={true}
              isSubmitting={isSaving}
            />
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
